import { render, staticRenderFns } from "./ChromatogramControl.vue?vue&type=template&id=12da16c6&scoped=true&"
import script from "./ChromatogramControl.vue?vue&type=script&lang=js&"
export * from "./ChromatogramControl.vue?vue&type=script&lang=js&"
import style0 from "./ChromatogramControl.vue?vue&type=style&index=0&id=12da16c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da16c6",
  null
  
)

export default component.exports